import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { UrlCollection } from "../app-routing.module";
import { PermissionService } from "./permission.service";

/**
 * Le pagine delle MANUTENZIONI INTERNE vivono nei soli contesti Cliente e Supervisore.
 *
 * Perche' serve una guardia in piu' accanto a `PermissionGuardFn`: quest'ultima decide con
 * `PermissionService.can()`, che ha DUE scorciatoie prima del vincolo di contesto — la scorciatoia
 * sul profilo SUPER_ADMIN e, dentro `isActionAllowed`, la deroga `BYPASS_ALL_POLICIES`. Un
 * SuperAdmin di organizzazione FORNITRICE passerebbe quindi la guardia dei permessi, aprirebbe la
 * pagina e riceverebbe 401 su ogni chiamata: il backend il divieto lo applica sul dato
 * (`AuthorizationUtils.canAccessInternalMaintenances`), e per l'analisi Milestone 3 «nessun utente
 * di contesto Fornitore, a prescindere dal ruolo» le vede.
 *
 * Le due guardie si combinano nella stessa rotta: `PermissionGuardFn` risponde «hai il permesso?»,
 * questa risponde «sei nel contesto giusto?». Tenerle separate evita di infilare un caso speciale
 * dentro la guardia generica, che protegge ogni pagina dell'applicazione.
 */
export async function InternalMaintenanceGuardFn(): Promise<boolean> {
    const router = inject(Router);
    const permissions = inject(PermissionService);

    if (permissions.canAccessInternalMaintenances()) {
        return true;
    }

    await router.navigate([UrlCollection.forbidden]);
    return false;
}
